import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route, Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import {from, Observable, of} from 'rxjs';
import { AuthService } from '@brightside-web/desktop/data-access/shared';
import {
  BsAuthService,
  BsCacheService
} from "@brightside-web/desktop/data-access/core-services";
import {map, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class GuidGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router:Router,
    private bsAuthService: BsAuthService,
    private bsCacheService: BsCacheService
    ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return from(this.bsAuthService.fetchUserAttributes()).pipe(
      map(attributes => {
        if (!attributes) {
          this.router.navigate(['registration/create-account']);
          return false;
        } else {
          if (state.url.includes('home')) {
            if (attributes['guid']) {
              return true;
            } else {
              this.router.navigate(['registration/select-employer']);
              return false;
            }
          } else {
            // else is meant to cover registration paths
            if (attributes['guid']) {
              this.router.navigate(['/home']);
              return false;
            } else {
              return true;
            }
          }
        }
      })
    );
  }
}
